import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGO_URL = "/logo-square.jpg";

export const SOCIALS = {
  facebook: "https://www.facebook.com/share/19UKtCZLud/",
  instagram: "https://www.instagram.com/bengalumrahhouse",
};

export const HERO_IMG =
  "https://images.unsplash.com/photo-1720549973451-018d3623b55a?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";
export const MADINAH_IMG =
  "https://images.unsplash.com/photo-1692977579997-948328cdb7d2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

// Remember a ?ref= joining code from any page so signup later credits the right member.
export const getJoinRef = () => {
  const r = new URLSearchParams(window.location.search).get("ref");
  if (r) localStorage.setItem("join_ref", r.trim());
  return localStorage.getItem("join_ref") || "";
};

const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  const ws = localStorage.getItem("workspace_id");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (ws) config.headers["X-Workspace-Id"] = ws;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.includes("login")) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const portalApi = axios.create({ baseURL: API });
portalApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("portal_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const staffApi = axios.create({ baseURL: API });
staffApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("staff_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function apiError(detail) {  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const roleLabel = (r) => ({ owner: "Company", agent: "Associate Partner", coworker: "Associate Partner", staff: "Office staff" }[r] || r);
export const levelLabel = (l) => `Associate Partner · Level ${String(l || 1).padStart(2, "0")}`;

export const inr = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);

export const timeAgo = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
};

export const fmtTime = (iso) =>
  new Date(iso).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });

export default api;
